import React, { ReactNode } from 'react';
import {
    TextField,
    Filter,
    TextInput,
    DateField,
    EditButton,
    ReferenceField,
} from 'react-admin';
import CustomizableGrid from '../components/CustomizableGrid';
import { ColumnConfig } from '../hooks/useColumnReorder';
import CustomSearchInput from '../components/CustomSearchInput';

const StaffFilter = props => (
    <Filter variant="outlined" {...props}>
        <CustomSearchInput alwaysOn />
    </Filter>
);

const Roles = ({ record }: any) => {
    const roles = record.roles;
    return (
        roles && (
            <ul>
                {roles.sort().map(r => (
                    <li key={r}>{r}</li>
                ))}
            </ul>
        )
    );
};

const StaffList = ({ permissions = [], ...props }) => {
    // Define default columns configuration
    const defaultColumns: ColumnConfig[] = [
        { id: 'serial', label: 'Serial', visible: true, order: 0 },
        { id: 'id', label: 'UserId', visible: true, order: 1 },
        { id: 'createdAt', label: 'Created', visible: true, order: 2 },
        { id: 'user', label: 'User', visible: true, order: 3 },
        { id: 'roles', label: 'Roles', visible: true, order: 4 },
        { id: 'edit', label: 'Edit', visible: true, order: 5 },
    ];

    // Function to render column based on column ID
    const renderColumn = (columnId: string): ReactNode => {
        switch (columnId) {
            case 'serial':
                return (
                    <TextField
                        key={columnId}
                        source="serial"
                        sortable={false}
                    />
                );
            case 'id':
                return <TextField key={columnId} source="id" label="UserId" />;
            case 'createdAt':
                return (
                    <DateField
                        key={columnId}
                        locales="en-IN"
                        source="createdAt"
                        label="Created"
                        showTime
                    />
                );
            case 'user':
                return (
                    <ReferenceField
                        key={columnId}
                        label="User"
                        source="id"
                        reference="users"
                        link="show"
                    >
                        <TextField source="name" />
                    </ReferenceField>
                );
            case 'roles':
                return <Roles key={columnId} />;
            case 'edit':
                return (
                    <EditButton
                        key={columnId}
                        color="secondary"
                        style={{ padding: 0 }}
                    />
                );
            default:
                return null;
        }
    };

    // Ensure we have all required props, but avoid duplicates with what might be in props
    const combinedProps = {
        title: 'Permissions',
        permissions,
        defaultColumns,
        storageKey: 'staffListColumns',
        renderColumn,
        bulkActionButtons: false,
        filtersComponent: <StaffFilter />,
        sort: { field: 'id', order: 'DESC' },
        ...props,
        // Ensure these are set if not in props
        resource: props.resource || 'staff', // Note: changed from 'orders' to 'staff'
        location: props.location || { search: '' },
        hasShow: props.hasShow !== undefined ? props.hasShow : false,
    };

    return <CustomizableGrid {...combinedProps} />;
};

StaffList.defaultProps = {
    resource: 'staff',
    location: { search: '' },
};

export default StaffList;
